import { forwardRef } from 'react';
import { ReadOnlyMultiple } from './ReadOnlyMultiple';
import { ReadOnlySingle } from './ReadOnlySingle';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const ReadOnlyComboBox = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    size,
    selectedOptions,
    multiple,
    id,
    ...rest
  } = props;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: multiple ? /*#__PURE__*/_jsx(ReadOnlyMultiple, {
      id: id,
      "data-testid": rest['data-testid'],
      selectedOptions: selectedOptions,
      size: size
    }) : /*#__PURE__*/_jsx(ReadOnlySingle, {
      id: id,
      "data-testid": rest['data-testid'],
      selectedOptions: selectedOptions,
      size: size
    })
  });
});
ReadOnlyComboBox.displayName = 'ReadOnlyComboBox';